import React from "react";
import { Button } from "@instructure/ui-buttons";
import { Spinner } from "@instructure/ui-spinner";
import { IconDownloadLine, IconRefreshLine } from "@instructure/ui-icons";
import { DTI_REFRESH_HINT } from "./DtiRefreshLabel";

export default function DtiToolbar({
  isLoading = false,
  onRefresh,
  onExport,
  isExporting = false,
  exportLabel = "Tải báo cáo Excel",
  successMessage = null,
  hint = DTI_REFRESH_HINT,
}) {
  return (
    <div className="dti-toolbar">
      <p className="dti-toolbar__hint">{hint}</p>
      <div className="dti-toolbar__actions">
        {successMessage && (
          <span className="dti-toolbar__status">{successMessage}</span>
        )}
        {onRefresh && (
          <Button
            onClick={onRefresh}
            color="primary"
            size="small"
            disabled={isLoading}
            renderIcon={isLoading ? undefined : IconRefreshLine}
          >
            {isLoading ? (
              <Spinner renderTitle="Đang tải" size="x-small" />
            ) : (
              "Cập nhật dữ liệu"
            )}
          </Button>
        )}
        {onExport && (
          <Button
            onClick={onExport}
            color="secondary"
            size="small"
            disabled={isExporting || isLoading}
            renderIcon={IconDownloadLine}
          >
            {isExporting ? (
              <Spinner renderTitle="Đang xuất" size="x-small" />
            ) : (
              exportLabel
            )}
          </Button>
        )}
      </div>
    </div>
  );
}
